import * as React from 'react';
import { Form, Row } from 'react-bootstrap';
import { Multiselect } from 'multiselect-react-dropdown';
import { INameValue, MultiSelectOption } from './common';

export interface IMultiSelectListStateProps {
  options: INameValue[];
  className?: string;
  placeHolder?: string;
  datafield?: string;
  title?: string;
  name?: string;
  selections?: INameValue[];
}

interface IMultiSelectListActions {
  onSelect?: (selectedList: any, selectedItem: any) => void;
  onRemove?: (selectedList: any, selectedItem: any) => void;
}

export interface IMultiSelectListProps
  extends IMultiSelectListStateProps,
    IMultiSelectListActions {}

const MultiSelectList: React.FC<IMultiSelectListProps> = ({
  onSelect,
  onRemove,
  options,
  placeHolder,
  title,
  selections,
}) => {
  // const msOptions: MultiSelectOption[] = options.map(
  //   (x: INameValue, idx) =>
  //     ({
  //       disabled: false,
  //       label: x.name,
  //       value: x.value,
  //       text: x.name,
  //       index: idx,
  //       selected:
  //         selections && selections.length > 0
  //           ? selections.filter((y) => y.toString() == x.value)[0] > 0
  //           : null,
  //     } as MultiSelectOption)
  // );

  // const selectedValues = msOptions.filter((option) => option.selected === true).map((x) => ({}));
  return (
    <Form.Group className='multiselectlist'>
      <Form.Label>
        <strong>{title}</strong>
      </Form.Label>
      <Multiselect
        options={options}
        selectedValues={selections}
        onSelect={onSelect}
        onRemove={onRemove}
        displayValue='name'
        placeHolder={placeHolder}
      />
    </Form.Group>
  );
};

export default MultiSelectList;
